//Infrastructure / Supabase adapter

import { supabase } from '../../../infra_/supabase/supabaseClient.js'

export const InventarioRepository = {
  async listar(filtros = {}) {
    let query = supabase
      .from("inventario_stock")
      .select(`
        stock_actual,
        stock_minimo,
        estado,
        productos_precio (
          *
        )
      `)
      .order("id_producto", { ascending: false });

    if (filtros.estado) {
      query = query.eq("estado", filtros.estado);
    }

    const { data, error } = await query;

    if (error) throw error;

    return data;
  },
};
